<template>
	<div class="support-team">
		<div class="page-container">
			<PageTitle ch="超偶特攻隊" en="Volunteer"></PageTitle>
			<BannerSplit2SupportTeam></BannerSplit2SupportTeam>
			<iframe src="https://goo.gl/UCnbba" frameborder="0"></iframe>
		</div>
	</div>
</template>


<script>
import PageTitle from '@/components/page_title'
import BannerSplit2SupportTeam from '@/components/banner/banner_split2_support_team'
export default {

  metaInfo: {
    title: '利澤國際偶戲藝術村'
  },
  name: 'support-team',
  data() {
    return {

    }
  },
  components: {
    PageTitle,
    BannerSplit2SupportTeam
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="sass">
  @import '../../stylesheet/base.sass'
  @import '../../stylesheet/layout.sass'

  .support-team
    iframe
      +size(100%, 1000px)

</style>



// WEBPACK FOOTER //
// src/pages/support/support_club.vue